import React from 'react'
import './invite-participants.scss'
import SessionCache from '../../routes/session-cache'
import { Modal, ModalBody } from 'reactstrap'
import { Constants, ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component'
import CommonUtils from '../../../utility/common-utilities'
import SchoolApi from '../../../apis/school'
import Dropdown from '../../common/dropdown-v2/dropdown'
import CommonApi from '../../../apis/common'

class ConfirmProfile extends React.Component {
  state = {
    mobileNumber: '',
    email: '',
    isWhatsappInvited: false,
    isEmailInvited: false,
    countryCodeDropdown: []
  }

  constructor(props) {
    super(props)
    let user = SessionCache.getUser()
    this.user = user
    this.state.mobileNumber = user.mobileNumber
    this.state.email = user.email
    this.state.countryCode = user.countryCode
    this.type = props.type

    this.getCountryCodes()
  }

  getCountryCodes(payload = {}) {
    CommonApi.getCountryCodeList(payload)
      .then(response => {
        let data = response.response
        if (data.length) {
          this.setState({ countryList: data })
          let countryCodeDropdown = this.buildCountryCodeDropdown(data)
          this.setState({ countryCodeDropdown })
        }
      })
      .catch(err => { })
  }

  buildCountryCodeDropdown(list = []) {
    let countryCodeDropdown = []
    let countryCodeHash = {}
    for (let i = 0; i < list.length; i++) {
      let item = list[i]

      if (!countryCodeHash[item.dialCode]) {
        countryCodeHash[item.dialCode] = item
        countryCodeDropdown.push({
          title: `${item.name} ${item.dialCode}`,
          value: item.dialCode
        })
      }
    }
    this.setState({ hashedCountryCode: countryCodeHash })
    return countryCodeDropdown
  }

  onCountryCodeSearch(value, index) {
    if (value.length > 2 || !value) {
      this.countryCodeIndex = index
      this.getCountryCodes({ name: `/${value}` })
    }
  }

  onSelectCountryCode(option) {
    this.setState({ countryCode: option?.value })
  }

  showToaster(type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster() {
    this.setState({
      showToaster: false
    })
  }

  copyLink = _ => {
    var dummy = document.createElement('textarea')
    // dummy.style.display = 'none'
    document.body.appendChild(dummy)
    dummy.value =
      `Dear Students,

    Countingwell Testing School has started using Countingwell for assigning and managing your Maths homework. Hereafter, we will start assigning you homework, tests and revision/practice tests through the Countingwell mobile app.
    
    ⛳Instruction
    
    1. Download the Countingwell App from this link: ${'https://t2m3p.app.link/idcLs5rNInb?schoolCode=' + this.user.schoolInfo.schoolCode}
    2. Register on the app or login if you have already registered
    3. Go to My Profile on the Countingwell app and the enter the school code:  ${this.user.schoolInfo.schoolCode}
    4. Tap on My Homeworks card on the Countingwell app to see the list of your assigned homework and start completing the homework.
    
    Download the Countingwell app from the above link, sign up and confirm.`
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    this.showToaster('info', 'Copied')
  }

  validateMobileNumber = _ => {
    console.log(
      this.state.hashedCountryCode,
      this.state.countryCode,
      this.state.mobileNumber
    )
    let countryCodeDetail = this.state.hashedCountryCode[this.state.countryCode]
    let validateCountryCode = CommonUtils.validateMobileNumber(
      this.state.mobileNumber,
      countryCodeDetail
    )
    if (!validateCountryCode) {
      this.setState({ isInvalidMobile: true })
      return false
    } else {
      this.setState({ isInvalidMobile: false, allowmobileNumber: false })
    }
  }

  validateEmail = _ => {
    let isValid = CommonUtils.validateEmail(this.state.email)
    if (!isValid) {
      this.setState({ isInvalidEmail: true })
    } else {
      this.setState({ isInvalidEmail: false, allowemail: false })
    }
  }

  onChangeHandler = (event, key) => {
    if (key == 'mobileNumber' && !this.state.mobileNumber) {
      if (!CommonUtils.isAllowMobileNumber(event.target.value)) {
        let stateValue = this.state.mobileNumber
        this.setState({ mobileNumber: '' }, () => {
          this.setState({ mobileNumber: stateValue })
        })
        return
      }
    }
    this.setState({ [key]: event.target.value })
  }

  allowEdit = key => {
    this.setState({
      ['allow' + key]: true,
      ['disable' + key]: true
    })
  }

  onContinue = _ => {
    this.props.onContinue()
  }

  updateInvite = type => {
    let payload = {
      inviteType: this.props.type
    }

    SchoolApi.updateInvite(payload)
      .then(_ => {
        if (this.props.type === 1) this.user.isStudentInvited = true
        if (this.props.type === 2) this.user.isTeacherInvited = true
        SessionCache.setUser(this.user)
        this.setState({
          isInviteSubmit: false,
          isWhatsappInvited: type === 1 ? true : false,
          isEmailInvited: type === 2 ? true : false
        })
      })
      .catch(err => {
        this.setState({ isInviteSubmit: false })
      })
  }

  sendInvitation = invitationType => {
    const { mobileNumber, countryCode, email } = this.state
    let payload = {
      mobileNumber,
      countryCode,
      email,
      invitationType,
      participantType: this.type,
      schoolCode: this.user.schoolInfo.schoolCode,
      adminName: this.user.name
    }
    this.setState({
      isInviteSubmit: true
    })
    SchoolApi.sendInvitation(payload)
      .then(response => {
        this.showToaster('info', 'Message shared successfully on Whatsapp')
        this.updateInvite(invitationType)
      })
      .catch(err => {
        this.showToaster('error', 'Something went wrong')
        this.setState({
          isInviteSubmit: false
        })
      })
  }

  render() {
    const {
      isEmailInvited,
      isWhatsappInvited,
      allowmobileNumber,
      toasterMessage,
      toasterType,
      mobileNumber,
      email,
      allowemail,
      isInviteSubmit,
      showToaster,
      countryCodeDropdown,
      countryCode,
      isInvalidMobile,
      isInvalidEmail
    } = this.state
    return (
      <Modal
        className='cw-custom-modal-right custom-toaster-modal'
        isOpen={true}
        toggle={this.props.onClose}
        size={'lg'}
      >
        <ModalBody>
          <div className='confirm-profile-dashboard'>
            <div>
              <div className='abs-image'>
                <img
                  className='cursor-pointer header-image'
                  src={getImageSource(ImageConstants.HEADER1)}
                />
              </div>

              <div className='pt-4 my-auto'>
                <span className='step-title'>{this.props.step}</span>
                <span className='float-right'>
                  <img
                    className='close-icon cursor-pointer'
                    src={getImageSource(ImageConstants.CROSS)}
                    onClick={this.props.onClose}
                  />
                </span>
              </div>
            </div>
            <div>
              <div className='add-school'>
                {!this.state.loading ? (
                  <div className='row'>
                    <div className='col-9 '>
                      {!this.props.disableHeader ? (
                        <div className=''>
                          <strong className='header-text'>
                            {this.type === 1
                              ? 'Invite Students to Gulf Maths Challenge'
                              : 'Invite Teachers to Countingwell'}
                          </strong>
                        </div>
                      ) : (
                        ''
                      )}
                      <div className='pt-4'>
                        <div className='invite-participants center-box'>
                          <div className='pt-2'>
                            <span className='note'>
                              Alternately, you can enter a WhatsApp number below and click “Send Invite” to send this link via WhatsApp to your colleagues. You can even send it to yourself and then forward it to others from your WhatsApp number.
                            </span>
                          </div>
                          <div className='row share-container mt-2 my-2'>
                            <div className='col-11 note '>
                              You can click on the icon on the right or copy the
                              link below and paste it in any communication you
                              wish to send to your contacts.
                              <a
                                className='share-link'
                                href={
                                  this.type === 1
                                    ? 'https://t2m3p.app.link/idcLs5rNInb?schoolCode=' +
                                    this.user.schoolInfo.schoolCode
                                    : 'https://t2m3p.app.link/idcLs5rNInb?schoolCode=' +
                                    this.user.schoolInfo.schoolCode
                                }
                                target='_blank'
                              >
                                {this.type === 1
                                  ? 'https://t2m3p.app.link/idcLs5rNInb?schoolCode=' +
                                  this.user.schoolInfo.schoolCode
                                  : 'https://t2m3p.app.link/idcLs5rNInb?schoolCode=' +
                                  this.user.schoolInfo.schoolCode}
                              </a>
                            </div>
                            <div className='col-1'>
                              <a
                                className='clone-link cursor-pointer'
                                onClick={this.copyLink}
                              >
                                <img
                                  className='clone-icn'
                                  src={getImageSource(
                                    ImageConstants.CLONE_ICON
                                  )}
                                />
                              </a>
                            </div>
                          </div>
                          <div className='mt-4'>
                            <strong className='share-title'>
                              Share this link with me:
                            </strong>
                            <div className='input-container'>
                              <div className='input-box inline-block'>
                                {countryCodeDropdown?.length && (
                                  <div className='cw-country-code d-inline-block'>
                                    <Dropdown
                                      key='countryCode'
                                      placeholder='Search country code'
                                      options={countryCodeDropdown}
                                      onSelect={option =>
                                        this.onSelectCountryCode(option)
                                      }
                                      text='title'
                                      onSearch={value =>
                                        this.onCountryCodeSearch(value)
                                      }
                                      style={{ background: '#F6F7F5' }}
                                      value={countryCode}
                                      disabled={!allowmobileNumber}
                                    />
                                  </div>
                                )}
                                <span className='cw-separator'></span>
                                <input
                                  className={`cw-mobile-number cw-input-left ${!allowmobileNumber && 'not-editable'}`}
                                  placeholder='Enter Mobile Number'
                                  value={mobileNumber}
                                  onChange={e =>
                                    this.onChangeHandler(e, 'mobileNumber')
                                  }
                                  disabled={!allowmobileNumber}
                                />
                                {!allowmobileNumber && (
                                  <span
                                    className='pencil-icn-container cursor-pointer'
                                    onClick={_ =>
                                      this.allowEdit('mobileNumber')
                                    }
                                  >
                                    <img
                                      className='pencil-icn'
                                      src={getImageSource(
                                        ImageConstants.PENCIL_ICON
                                      )}
                                      align='right'
                                    />
                                  </span>
                                )}
                                {allowmobileNumber && (
                                  <span
                                    className='cw-button-update'
                                    onClick={_ => this.validateMobileNumber()}
                                  >
                                    Update
                                  </span>
                                )}
                              </div>
                              <div
                                className={`input-button inline-block cw-button-invite ${allowmobileNumber && 'button-disabled'}`}
                                onClick={_ =>
                                  !allowmobileNumber && !isInviteSubmit &&
                                  this.sendInvitation(1)
                                }
                              >
                                <span className='button-text'>
                                  SHARE ON WHATSAPP
                                </span>
                              </div>
                            </div>
                            <div className='col'>
                              {isInvalidMobile && mobileNumber && (
                                <span className='invalid-text'>
                                  Enter valid phone number
                                </span>
                              )}
                            </div>
                            <div className='input-container'>
                              <div className='input-box inline-block'>
                                <input
                                  className={`cw-input-left cw-email-input  ${!allowemail && 'not-editable'}`}
                                  placeholder='Enter your Email'
                                  value={email}
                                  onChange={e =>
                                    this.onChangeHandler(e, 'email')
                                  }
                                  disabled={!allowemail}
                                />
                                {!allowemail && (
                                  <span
                                    className='pencil-icn-container cursor-pointer'
                                    onClick={_ => this.allowEdit('email')}
                                  >
                                    <img
                                      className='pencil-icn'
                                      src={getImageSource(
                                        ImageConstants.PENCIL_ICON
                                      )}
                                      align="right"
                                    />
                                  </span>
                                )}
                                {allowemail && (
                                  <span
                                    className='cw-button-update'
                                    onClick={_ => this.validateEmail()}
                                  >
                                    Update
                                  </span>
                                )}
                              </div>
                              <div
                                className={`input-button inline-block cw-button-invite cw-button-blue  ${allowemail && 'button-disabled'}`}
                                onClick={_ =>
                                  !allowemail && !isInviteSubmit && this.sendInvitation(2)
                                }
                              >
                                <span className='button-text'>
                                  SHARE ON EMAIL
                                </span>
                              </div>
                            </div>
                            <div className='col'>
                              {isInvalidEmail && email && (
                                <span className='invalid-text'>
                                  Enter valid email
                                </span>
                              )}
                            </div>
                            <div className='note-text pt-4'>
                              <div className='bulb-img-container inline-block'>
                                <img
                                  className='bulb-img'
                                  src={getImageSource(ImageConstants.BULB)}
                                />
                              </div>
                              <div className='note-text inline-block pl-1 pt-1'>
                                {this.type === 1
                                  ? `Once you get the message on WhatsApp / Email, you can forward it to other teachers, groups and students.`
                                  : `You would have received the message to be shared. You can now forward it to other teachers, groups and students.`}
                              </div>
                            </div>

                            <div
                              className='continue-button text-center'
                              onClick={this.onContinue}
                            >
                              {isWhatsappInvited && (
                                <div className='footer-text-hover cursor-pointer'>
                                  Message shared successfully on Whatsapp
                                </div>
                              )}
                              {isEmailInvited && (
                                <div className='footer-text-hover cursor-pointer'>
                                  Message shared successfully on Email
                                </div>
                              )}
                              {/* {!isWhatsappInvited && !isEmailInvited && (
                                <div className='footer-text cursor-pointer'>
                                  Done
                                </div>
                              )} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
              {showToaster ? (
                <ToasterComponent message={toasterMessage} type={toasterType} position="bottom-center" />
              ) : (
                ''
              )}
            </div>
          </div>
        </ModalBody>
      </Modal>
    )
  }
}

export default ConfirmProfile
